module.exports = __webpack_public_path__ + "19029829aa5fdc4115804b998717cb51.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/raisa-cuevas.jpg
// module id = 452
// module chunks = 0